import { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '../../firebase';
import { onAuthStateChanged, getIdTokenResult, getRedirectResult } from 'firebase/auth';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [approved, setApproved] = useState(false);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // OPTIONAL: Check for redirect login errors (can be useful for debugging)
  useEffect(() => {
    getRedirectResult(auth)
      .then((result) => {
        if (result?.user) {
          console.log('Redirect result user:', result.user.email);
        } else {
          console.log('No redirect result user found');
        }
      })
      .catch((err) => {
        console.error('Redirect result error:', err);
      });
  }, []);

  // MAIN: Restore Firebase auth session
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      //console.log('🔁 onAuthStateChanged user:', firebaseUser);

      if (firebaseUser) {
        setUser(firebaseUser);
        try {
          const token = await getIdTokenResult(firebaseUser);
          //console.log('👤 Token claims:', token.claims);
          setApproved(token.claims.approved === true);
          
          // Extract role from custom claims
          const userRole = token.claims.role || 'USER'; // Default to USER if no role specified
          setRole(userRole);
          //console.log('👤 User role:', userRole);
        } catch (err) {
          console.error('Error fetching token result:', err);
          setApproved(false);
          setRole(null);
        }
      } else {
        setUser(null);
        setApproved(false);
        setRole(null);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, approved, role, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}


